import { Descriptions } from 'antd';
import { CodeBlock, github } from 'react-code-blocks';

import { RequestInnerResponseInterface } from '@interface/logs/logs.interface';

interface ResponseInfoProps {
  response: RequestInnerResponseInterface;
}

const codeBlockStyle = {
  backgroundColor: 'transparent',
  maxHeight: '500px',
  overflowY: 'auto',
};

export const ResponseInfo = ({ response }: ResponseInfoProps) => (
  <Descriptions size='small' title='Response' bordered>
    <Descriptions.Item label='Status' labelStyle={{ width: 120 }} span={2}>
      {response.status ?? '-'}
    </Descriptions.Item>
    <Descriptions.Item label='Latency' labelStyle={{ width: 120 }} span={2}>
      {response.latencyMs ?? 0}ms
    </Descriptions.Item>
    <Descriptions.Item label='Headers' span={3}>
      <CodeBlock
        customStyle={codeBlockStyle}
        language='json'
        showLineNumbers={false}
        text={JSON.stringify(JSON.parse(response.headers ?? '{}'), null, 4)}
        theme={github}
      />
    </Descriptions.Item>
    <Descriptions.Item label='Body' span={3}>
      <CodeBlock
        customStyle={codeBlockStyle}
        language='json'
        showLineNumbers={false}
        text={JSON.stringify(JSON.parse(response.body ?? '{}'), null, 4)}
        theme={github}
      />
    </Descriptions.Item>
  </Descriptions>
);
